import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/project',
      name: 'project',
      component: () => import('@/views/management/Project.vue'),
      meta: {
        pageTitle: 'Project',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Project',
            active: true,
          },
        ],
      },
    },
    {
      path: '/solution',
      name: 'solution',
      component: () => import('@/views/solution/Solution.vue'),
      meta: {
        pageTitle: 'Solution',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Solution',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/user/User.vue'),
      meta: {
        pageTitle: 'User',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'User',
            active: true,
          },
        ],
      },
    },
    {
      path: '/contractor',
      name: 'contractor',
      component: () => import('@/views/contractor/Contractor.vue'),
      meta: {
        pageTitle: 'Contractor',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Contractor',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tunnel-total',
      name: 'tunnel-total',
      component: () => import('@/views/tunnel/TunnelTotal.vue'),
      meta: {
        pageTitle: 'TunnelTotal',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'TunnelTotal',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tunnel-sub',
      name: 'tunnel-sub',
      component: () => import('@/views/tunnel/TunnelSub.vue'),
      meta: {
        pageTitle: 'TunnelSub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'TunnelSub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/traffic-detail',
      name: 'traffic-detail',
      component: () => import('@/views/traffic/TrafficDetail.vue'),
      meta: {
        pageTitle: 'Traffic',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Traffic',
            active: true,
          },
        ],
      },
    },
    {
      path: '/traffic-sub',
      name: 'traffic-sub',
      component: () => import('@/views/traffic/TrafficSub.vue'),
      meta: {
        pageTitle: 'TrafficSub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'TrafficSub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/traffic-total',
      name: 'traffic-total',
      component: () => import('@/views/traffic/TrafficTotal.vue'),
      meta: {
        pageTitle: 'Traffic',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Traffic',
            active: true,
          },
        ],
      },
    },
    {
      path: '/way',
      name: 'way',
      component: () => import('@/views/Way/Way.vue'),
      meta: {
        pageTitle: 'Way',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Way',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportpoleday',
      name: 'reportpoleday',
      component: () => import('@/views/lighting/Report/ReportPoleDay.vue'),
      meta: {
        pageTitle: 'Reportday',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Reportday',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportpolemonth',
      name: 'reportpolemonth',
      component: () => import('@/views/lighting/Report/ReportPoleMonth.vue'),
      meta: {
        pageTitle: 'ReportPoleMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportPoleMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportpoleyear',
      name: 'reportpoleyear',
      component: () => import('@/views/lighting/Report/ReportPoleYear.vue'),
      meta: {
        pageTitle: 'ReportPoleYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportPoleYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrolday',
      name: 'reportsemcontrolday',
      component: () => import('@/views/lighting/Report/ReportSemControlDay.vue'),
      meta: {
        pageTitle: 'ReportSemControlDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrolmonth',
      name: 'reportsemcontrolmonth',
      component: () => import('@/views/lighting/Report/ReportSemControlMonth.vue'),
      meta: {
        pageTitle: 'ReportSemControlMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrolyear',
      name: 'reportsemcontrolyear',
      component: () => import('@/views/lighting/Report/ReportSemControlYear.vue'),
      meta: {
        pageTitle: 'ReportSemControlYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepairday',
      name: 'reportrepairday',
      component: () => import('@/views/lighting/Report/ReportRepairDay.vue'),
      meta: {
        pageTitle: 'ReportRepairDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepairmonth',
      name: 'reportrepairmonth',
      component: () => import('@/views/lighting/Report/ReportRepairMonth.vue'),
      meta: {
        pageTitle: 'ReportRepairMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepairyear',
      name: 'reportrepairyear',
      component: () => import('@/views/lighting/Report/ReportRepairYear.vue'),
      meta: {
        pageTitle: 'ReportRepairYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/counting-total',
      name: 'counting-total',
      component: () => import('@/views/counting/CountingTotal.vue'),
      meta: {
        pageTitle: 'Counting Total',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Counting Total',
            active: true,
          },
        ],
      },
    },
    {
      path: '/counting-sub',
      name: 'counting-sub',
      component: () => import('@/views/counting/CountingSub.vue'),
      meta: {
        pageTitle: 'Counting Sub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Counting Sub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/counting-detail',
      name: 'counting-detail',
      component: () => import('@/views/counting/CountingDetail.vue'),
      meta: {
        pageTitle: 'Counting Detail',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Counting Detail',
            active: true,
          },
        ],
      },
    },
    {
      path: '/countingnospeed-detail',
      name: 'countingnospeed-detail',
      component: () => import('@/views/counting/CountingDetailNoSpeed.vue'),
      meta: {
        pageTitle: 'CountingNoSpeed Detail',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'CountingNoSpeed Detail',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analytic-detail',
      name: 'analytic-detail',
      component: () => import('@/views/analytic120/AnalyticDetail.vue'),
      meta: {
        pageTitle: 'Analytic',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Analytic',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vms-detail',
      name: 'vms-detail',
      component: () => import('@/views/vms/VmsDetail.vue'),
      meta: {
        pageTitle: 'VMS',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'VMS',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vms-sub',
      name: 'vms-sub',
      component: () => import('@/views/vms/VmsSub.vue'),
      meta: {
        pageTitle: 'VMS',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'VMS',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vms-total',
      name: 'vms-total',
      component: () => import('@/views/vms/VmsTotal.vue'),
      meta: {
        pageTitle: 'VMS',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'VMS',
            active: true,
          },
        ],
      },
    },
    {
      path: '/flooding-sub',
      name: 'flooding-sub',
      component: () => import('@/views/flooding/FloodingSub.vue'),
      meta: {
        pageTitle: 'Flooding',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Flooding',
            active: true,
          },
        ],
      },
    },
    {
      path: '/flooding-detail',
      name: 'flooding-detail',
      component: () => import('@/views/flooding/FloodingDetail.vue'),
      meta: {
        pageTitle: 'Flooding',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Flooding',
            active: true,
          },
        ],
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/traffic-sci-fi',
      name: 'traffic-sci-fi',
      component: () => import('@/views/traffiscifi/TrafficSciFiDetail2.vue'),
      meta: {
        pageTitle: 'Traffic Sci Fi',
        breadcrumb: [
          {
            text: 'Traffic Sci Fi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analytic-sci-fi',
      name: 'analytic-sci-fi',
      component: () => import('@/views/analyticscifi/AnalyticSciFiDetail2.vue'),
      meta: {
        pageTitle: 'Analytic Sci Fi',
        breadcrumb: [
          {
            text: 'Analytic Sci Fi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/counting-sci-fi',
      name: 'counting-sci-fi',
      component: () => import('@/views/countingscifi1/CountingSciFiDetail.vue'),
      meta: {
        pageTitle: 'Counting Sci Fi',
        breadcrumb: [
          {
            text: 'Counting Sci Fi',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cctv-total',
      name: 'cctv-total',
      component: () => import('@/views/cctv/CCTVTotal.vue'),
      meta: {
        pageTitle: 'Second Page',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cctv-sub',
      name: 'cctv-sub',
      component: () => import('@/views/cctv/CCTVSub.vue'),
      meta: {
        pageTitle: 'CCTV Sub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'CCTV Sub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cctv-detail',
      name: 'cctv-detail',
      component: () => import('@/views/cctv/CCTVDetail.vue'),
      meta: {
        pageTitle: 'Second Page',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/wim-sub',
      name: 'wim-sub',
      component: () => import('@/views/wim/WIMSub.vue'),
      meta: {
        pageTitle: 'WIM Sub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'WIM Sub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/wim-detail',
      name: 'wim-detail',
      component: () => import('@/views/wim/WIMDetail.vue'),
      meta: {
        pageTitle: 'WIM Detail',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'WIM Detail',
            active: true,
          },
        ],
      },
    },
    {
      path: '/wim-table',
      name: 'wim-table',
      component: () => import('@/views/wim/table/WIMTableTruck.vue'),
      meta: {
        pageTitle: 'WIM Table',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'WIM Table',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analytic120-total',
      name: 'analytic120-total',
      component: () => import('@/views/analytic120/AnalyticTotal.vue'),
      meta: {
        pageTitle: 'Analytic120',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Analytic120',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analytic-sub',
      name: 'analytic-sub',
      component: () => import('@/views/analytic120/AnalyticSub.vue'),
      meta: {
        pageTitle: 'Analytic',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Analytic',
            active: true,
          },
        ],
      },
    },
    {
      path: '/analytic-detailCarstop',
      name: 'analytic-detailCarstop',
      component: () => import('@/views/analytic120/AnalyticDetailCarstop.vue'),
      meta: {
        pageTitle: 'Analytic',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Analytic',
            active: true,
          },
        ],
      },
    },
    {
      path: '/lightingdecorative-detail',
      name: 'lightingdecorative-detail',
      component: () => import('@/views/lightingdecorative/DecorativeDetail.vue'),
      meta: {
        pageTitle: 'lightingdecorative',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'lightingdecorative',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sensorflooding-total',
      name: 'sensorflooding-total',
      component: () => import('@/views/sensor/flooding/SensorFloodingTotal.vue'),
      meta: {
        pageTitle: 'SensorFlooding',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'SensorFlooding',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sensorlux-total',
      name: 'sensorlux-total',
      component: () => import('@/views/sensor/lux/SensorLuxTotal.vue'),
      meta: {
        pageTitle: 'SensorLux',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'SensorLux',
            active: true,
          },
        ],
      },
    },
    // {
    //   path: '/sensor-total',
    //   name: 'sensor-total',
    //   component: () => import('@/views/sensor/SensorTotal.vue'),
    //   meta: {
    //     pageTitle: 'Sensor',
    //     breadcrumb: [
    //       {
    //         text: 'Sensor',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/sensor-sub',
    //   name: 'sensor-sub',
    //   component: () => import('@/views/sensor/SensorSub.vue'),
    //   meta: {
    //     pageTitle: 'Sensor',
    //     breadcrumb: [
    //       {
    //         text: 'Sensor',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/sensor-detail',
    //   name: 'sensor-detail',
    //   component: () => import('@/views/sensor/SensorDetail.vue'),
    //   meta: {
    //     pageTitle: 'Sensor',
    //     breadcrumb: [
    //       {
    //         text: 'Sensor',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/tunnel-detail',
    //   name: 'tunnel-detail',
    //   component: () => import('@/views/sensor/tunnel/TunnelDetail.vue'),
    //   meta: {
    //     pageTitle: 'Tunnel',
    //     breadcrumb: [
    //       {
    //         text: 'Tunnel',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: '/bridge-sub',
      name: 'bridge-sub',
      component: () => import('@/views/sensor/bridge/BridgeSub.vue'),
      meta: {
        pageTitle: 'Bridge Sub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Bridge Sub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bridge-detail',
      name: 'bridge-detail',
      component: () => import('@/views/sensor/bridge/BridgeDetail.vue'),
      meta: {
        pageTitle: 'Bridge',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Bridge',
            active: true,
          },
        ],
      },
    },
    {
      path: '/4g-total',
      name: '4g-total',
      component: () => import('@/views/lighting/4G_NB-IoT.vue'),
      meta: {
        pageTitle: '',
        requiresAuth: true,
        breadcrumb: [
          {
            text: '',
            active: true,
          },
        ],
      },
    },
    {
      path: '/4g-sub',
      name: '4g-sub',
      component: () => import('@/views/lighting/4G-Sub.vue'),
      meta: {
        pageTitle: '4GSub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: '4G Sub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/lighting-sub',
      name: 'lighting-sub',
      component: () => import('@/views/lighting/SEMControlSub.vue'),
      meta: {
        pageTitle: 'LightingSub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Lighting Sub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bridgelighting-sub',
      name: 'bridgelighting-sub',
      component: () => import('@/views/lightingdecorative/BridgeLightingSub.vue'),
      meta: {
        pageTitle: 'Bridge LightingSub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Bridge Lighting Sub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/semcontrol-total',
      name: 'semcontrol-total',
      component: () => import('@/views/lighting/SEMControlTotal.vue'),
      meta: {
        pageTitle: 'semcontrol',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'semcontrol',
            active: true,
          },
        ],
      },
    },
    {
      path: '/semcontrol-detail',
      name: 'semcontrol-detail',
      component: () => import('@/views/lighting/SEMControlDetail.vue'),
      meta: {
        pageTitle: 'semcontrol',
        breadcrumb: [
          {
            text: 'semcontrol',
            active: true,
          },
        ],
      },
    },
    {
      path: '/SEMNB-iotCab3P',
      name: 'SEMNB-iotCab3P',
      component: () => import('@/views/lighting/SEMNB-iotCab3P.vue'),
      meta: {
        pageTitle: 'NB-I0T 3 Phase',
        breadcrumb: [
          {
            text: 'NB-I0T 3 Phase',
            active: true,
          },
        ],
      },
    },
    {
      path: '/semcontrol-detail1',
      name: 'semcontrol-detail1',
      component: () => import('@/views/lighting/SEMControlDetail1.vue'),
      meta: {
        pageTitle: 'semcontrol1',
        breadcrumb: [
          {
            text: 'semcontrol1',
            active: true,
          },
        ],
      },
    },
    {
      path: '/semcontrol-problem',
      name: 'semcontrol-problem',
      component: () => import('@/views/lighting/SEMControlProblem.vue'),
      meta: {
        pageTitle: 'semcontrol-problem',
        breadcrumb: [
          {
            text: 'semcontrol-problem',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sem-detail',
      name: 'sem-detail',
      component: () => import('@/views/lighting/semdetail/SEMMap.vue'),
      meta: {
        pageTitle: 'sem',
        breadcrumb: [
          {
            text: 'sem',
            active: true,
          },
        ],
      },
    },
    {
      path: '/nbiot-lora',
      name: 'nbiot-lora',
      component: () => import('@/views/lighting/SEMNB-iotLora.vue'),
      meta: {
        pageTitle: 'sem',
        breadcrumb: [
          {
            text: 'sem',
            active: true,
          },
        ],
      },
    },
    {
      path: '/crosswalk-total',
      name: 'crosswalk-total',
      component: () => import('@/views/crosswalk/CrossWalkTotal.vue'),
      meta: {
        pageTitle: 'CrossWalkTotal',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'CrossWalkTotal',
            active: true,
          },
        ],
      },
    },
    {
      path: '/crosswalk-sub',
      name: 'crosswalk-sub',
      component: () => import('@/views/crosswalk/CrossWalkSub.vue'),
      meta: {
        pageTitle: 'CrossWalkSub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'CrossWalkSub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/crosswalk-detail',
      name: 'crosswalk-detail',
      component: () => import('@/views/crosswalk/CrossWalkDetail.vue'),
      meta: {
        pageTitle: 'CrossWalkDetail',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'CrossWalkDetail',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reverse-detail',
      name: 'reverse-detail',
      component: () => import('@/views/reverse/ReverseDetail.vue'),
      meta: {
        pageTitle: 'reverse',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'reverse',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reverse-sub',
      name: 'reverse-sub',
      component: () => import('@/views/reverse/ReverseSub.vue'),
      meta: {
        pageTitle: 'ReverseSub',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReverseSub',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol1day',
      name: 'reportsemcontrol1day',
      component: () => import('@/views/lighting/Report1/ReportSemControlDay.vue'),
      meta: {
        pageTitle: 'ReportSemControlDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol1day-lora',
      name: 'reportsemcontrol1day-lora',
      component: () => import('@/views/lighting/Report2/ReportSemControlDay.vue'),
      meta: {
        pageTitle: 'ReportSemControlDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol3day',
      name: 'reportsemcontrol3day',
      component: () => import('@/views/lighting/Report3/ReportSemControlDay.vue'),
      meta: {
        pageTitle: 'ReportSemControlDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol1month',
      name: 'reportsemcontrol1month',
      component: () => import('@/views/lighting/Report1/ReportSemControlMonth.vue'),
      meta: {
        pageTitle: 'ReportSemControlMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol3month',
      name: 'reportsemcontrol3month',
      component: () => import('@/views/lighting/Report3/ReportSemControlMonth.vue'),
      meta: {
        pageTitle: 'ReportSemControlMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol1month-lora',
      name: 'reportsemcontrol1month-lora',
      component: () => import('@/views/lighting/Report2/ReportSemControlMonth.vue'),
      meta: {
        pageTitle: 'ReportSemControlMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol1year',
      name: 'reportsemcontrol1year',
      component: () => import('@/views/lighting/Report1/ReportSemControlYear.vue'),
      meta: {
        pageTitle: 'ReportSemControlYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol1year-lora',
      name: 'reportsemcontrol1year-lora',
      component: () => import('@/views/lighting/Report2/ReportSemControlYear.vue'),
      meta: {
        pageTitle: 'ReportSemControlYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportsemcontrol3year',
      name: 'reportsemcontrol3year',
      component: () => import('@/views/lighting/Report3/ReportSemControlYear.vue'),
      meta: {
        pageTitle: 'ReportSemControlYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportSemControlYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair1day',
      name: 'reportrepair1day',
      component: () => import('@/views/lighting/Report1/ReportRepairDay.vue'),
      meta: {
        pageTitle: 'ReportRepairDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair1day-lora',
      name: 'reportrepair1day-lora',
      component: () => import('@/views/lighting/Report2/ReportRepairDay.vue'),
      meta: {
        pageTitle: 'ReportRepairDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair3day',
      name: 'reportrepair3day',
      component: () => import('@/views/lighting/Report3/ReportRepairDay.vue'),
      meta: {
        pageTitle: 'ReportRepairDay',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairDay',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair1month',
      name: 'reportrepair1month',
      component: () => import('@/views/lighting/Report1/ReportRepairMonth.vue'),
      meta: {
        pageTitle: 'ReportRepairMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair1month-lora',
      name: 'reportrepair1month-lora',
      component: () => import('@/views/lighting/Report2/ReportRepairMonth.vue'),
      meta: {
        pageTitle: 'ReportRepairMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair3month',
      name: 'reportrepair3month',
      component: () => import('@/views/lighting/Report3/ReportRepairMonth.vue'),
      meta: {
        pageTitle: 'ReportRepairMonth',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairMonth',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair1year',
      name: 'reportrepair1year',
      component: () => import('@/views/lighting/Report1/ReportRepairYear.vue'),
      meta: {
        pageTitle: 'ReportRepairYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair1year-lora',
      name: 'reportrepair1year-lora',
      component: () => import('@/views/lighting/Report2/ReportRepairYear.vue'),
      meta: {
        pageTitle: 'ReportRepairYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reportrepair3year',
      name: 'reportrepair3year',
      component: () => import('@/views/lighting/Report3/ReportRepairYear.vue'),
      meta: {
        pageTitle: 'ReportRepairYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/semcontrol1-problem',
      name: 'semcontrol1-problem',
      component: () => import('@/views/lighting/SEMControl1Problem.vue'),
      meta: {
        pageTitle: 'semcontrol-problem',
        breadcrumb: [
          {
            text: 'semcontrol-problem',
            active: true,
          },
        ],
      },
    },
    {
      path: '/semcontrol1-problem-lora',
      name: 'semcontrol1-problem-lora',
      component: () => import('@/views/lighting/SEMControl2Problem.vue'),
      meta: {
        pageTitle: 'semcontrol-problem',
        breadcrumb: [
          {
            text: 'semcontrol-problem',
            active: true,
          },
        ],
      },
    },
    {
      path: '/semcontrol3p-problem',
      name: 'semcontrol3p-problem',
      component: () => import('@/views/lighting/SEMControl3Problem.vue'),
      meta: {
        pageTitle: 'semcontrol-problem',
        breadcrumb: [
          {
            text: 'semcontrol-problem',
            active: true,
          },
        ],
      },
    },
    {
      path: '/equipment',
      name: 'equipment',
      component: () => import('@/views/equipment/Equipment.vue'),
      meta: {
        pageTitle: 'ReportRepairYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/summary-project',
      name: 'summary-project',
      component: () => import('@/views/management/summary-project/Summary.vue'),
      meta: {
        pageTitle: 'ReportRepairYear',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'ReportRepairYear',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/Login.vue'),
      meta: {
        redirectIfLoggedIn: true,
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})
router.beforeEach((to, _, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const user = localStorage.getItem('userData')
    if (!user) {
      next({
        path: '/login',
      })
    } else {
      console.log(2)
    }
  } if (to.matched.some(record => record.meta.redirectIfLoggedIn)) {
    const user = localStorage.getItem('userData')
    if (user) {
      next({
        path: '/',
      })
    } else {
      next()
    }
  }
  return next()
})
// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
